/* May not work on Safari.
 * See src/components/organisms/ArticleListItem/ArticleListItemCopyShareLinkDialogForm.tsx
 * for an alternative way of doing it
 */

export const copyToClipboard = (text: string): Promise<void> =>
  navigator.clipboard.writeText(text).catch((error) => {
    // eslint-disable-next-line no-console
    console.warn(
      "Clipboard API not found, this copy function will not work. This is likely because you're using an unsupported browser or you're not using HTTPS.",
    );

    // eslint-disable-next-line no-console
    console.error(error);
  });
